// Footer.js
import React from 'react';
import './Footer.css';
import { FaDiscord, FaYoutube } from 'react-icons/fa';
import { BsClipboard2CheckFill } from 'react-icons/bs';
import { MdOutlineVideoLibrary } from "react-icons/md";
import paypalImg from './paypal.png';
import visaImg from './visa.png';
import mastercardImg from './mastercard.png';
import aliplayImg from './alipay.png';
import bitcoinImg from './bitcoin.png';
import etherImg from './ether.png';
import skinsImg from './skins.png';
import giftcardsImg from './giftcards.png';
import tetherImg from './tether.png';
import webmoneyImg from './webmoney.png';
import unionpayImg from './unionpay.png';
import eagleLogo from './eagle_logo.png';  // Imported eagle_logo.png

const Footer = React.memo(() => (
  <footer className="footer">
    {/* Animated pulsating line */}
    <div className="footer-line"></div>
    <div className="footer__inner">
      {/* Logo ganz links und verlinkt */}
      <div className="footer__section footer__section--left">
        <a href="https://eaglescript.space/" className="footer__logo-link">
          <img 
            src={eagleLogo} 
            alt="Eagle Script Logo" 
            className="footer__logo" 
          />
        </a>
      </div>

      {/* Second Column: Useful Links */}
      <div className="footer__section footer__section--left">
        <h3>USEFUL LINKS:</h3>
        <p>
         <a
           href="https://youtu.be/JElhwUVy9q8"
           target="_blank"
           rel="noopener noreferrer"
           className="footer__link"
         >
            <MdOutlineVideoLibrary className="footer__icon" /> How To Setup & Tutorial
          </a>
        </p>
        <p>
          <a
            href="#Tos"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__link"
          >
            <BsClipboard2CheckFill className="footer__icon" /> Terms Of Service
          </a>
        </p>
      </div>
      {/* Third Column: Pay With */}
      <div className="footer__section footer__section--left">
        <h3>PAY WITH:</h3>
        <div className="footer__grid">
          <div className="footer__grid-item">
            <img src={paypalImg}    alt="PayPal"       title="PayPal" />
          </div>
          <div className="footer__grid-item">
            <img src={visaImg}      alt="Visa"         title="Visa" />
          </div>
          <div className="footer__grid-item">
            <img src={mastercardImg}alt="Mastercard"   title="Mastercard" />
          </div>
          <div className="footer__grid-item">
            <img src={aliplayImg}   alt="Alipay"      title="Alipay" />
          </div>
          <div className="footer__grid-item">
            <img src={bitcoinImg}   alt="Bitcoin"      title="Bitcoin" />
          </div>
          <div className="footer__grid-item">
            <img src={etherImg}     alt="Ether"        title="Ethereum" />
          </div>
          <div className="footer__grid-item">
            <img src={skinsImg}     alt="Skins"        title="Pay with Skins" />
          </div>
          <div className="footer__grid-item">
            <img src={giftcardsImg} alt="Gift Cards"   title="Pay with Giftcards" />
          </div>
          <div className="footer__grid-item">
            <img src={tetherImg}    alt="Tether"       title="Tether" />
          </div>
          <div className="footer__grid-item">
            <img src={webmoneyImg}  alt="Webmoney"     title="Webmoney" />
          </div>
          <div className="footer__grid-item">
            <img src={unionpayImg}  alt="UnionPay"     title="UnionPay" />
          </div>
        </div>
      </div>
      {/* Fourth Column: Find Us On */}
      <div className="footer__section footer__section--left">
        <h3>FIND US ON:</h3>
        <div className="footer__contacts">
          <p>
            <a
              href="https://eaglescript.space:5989/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__link"
            >
              <FaDiscord className="footer__icon" /> Discord
            </a>
          </p>
          <p>
            <a
              href="https://www.youtube.com/@EAGLESCRIPT"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__link"
            >
              <FaYoutube className="footer__icon" /> YouTube
            </a>
          </p>
        </div>
      </div>
    </div>
    <div className="footer__copyright">
      Copyright © 2024 - 2025 Eagle Script, All Rights Reserved.
    </div>
  </footer>
));

export default Footer;